import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { StaticQuery } from 'gatsby';
import { LanguageContext } from '../../../providers';
import { findT } from '../../_helpers';
import { jsx as ___EmotionJSX } from "@emotion/react";
function SEO(_ref) {
  let {
    description,
    meta,
    image: metaImage,
    title,
    keywords
  } = _ref;
  const {
    language
  } = useContext(LanguageContext);
  return ___EmotionJSX(StaticQuery, {
    query: "613173270",
    render: data => {
      const seo = findT(data.directusProject.translations, language);
      const contact = data.directusCompany.company_name;
      const metaDescription = description || seo.seo_description;
      const seoKeywords = keywords.length === 0 ? seo.seo_keywords : keywords;
      const seoTitle = title || seo.seo_title;
      // TODO Image
      const image = metaImage && metaImage.src ? "" + data.site.siteMetadata.siteUrl + metaImage.src : null;
      return ___EmotionJSX(Helmet, {
        htmlAttributes: {
          lang: language
        },
        title: seoTitle,
        titleTemplate: seo.seo_title === seoTitle ? "" + seo.seo_title : "%s | " + seo.seo_title,
        meta: [{
          name: 'description',
          content: metaDescription
        }, {
          property: 'og:title',
          content: seoTitle
        }, {
          property: 'og:description',
          content: metaDescription
        }, {
          name: 'twitter:creator',
          content: contact.name
        }, {
          name: 'twitter:title',
          content: seoTitle
        }, {
          name: 'twitter:description',
          content: metaDescription
        }].concat(seoKeywords.length > 0 ? {
          name: "keywords",
          content: seoKeywords.join(", ")
        } : []).concat(metaImage ? [{
          property: 'og:image',
          content: image
        }, {
          property: 'og:image:width',
          content: metaImage.width
        }, {
          property: 'og:image:height',
          content: metaImage.height
        }, {
          name: 'twitter:card',
          content: 'summary_large_image'
        }] : [{
          name: 'twitter:card',
          content: 'summary'
        }]).concat(meta)
      });
    }
  });
}
SEO.defaultProps = {
  meta: [],
  keywords: []
};
export default SEO;